import type { SVGProps } from 'react';
const DawnFlagNO = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-NO_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-NO_svg__a)">
      <path
        fill="#F14247"
        d="M6.286 0H0v6.4h6.286zm3.143 0v6.4H22V0zM22 9.6H9.429V16H22zM6.286 16V9.6H0V16z"
      />
      <path
        fill="#0A3A85"
        d="M0 8.533h7.333V16h1.048V8.533H22V7.467H8.38V0H7.334v7.467H0z"
      />
    </g>
  </svg>
);
export default DawnFlagNO;
